var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SchoolName"},[_c('div',{staticClass:"dataScreen_top_left"},[_c('img',{staticClass:"dataScreen_top_left_img",attrs:{"src":"https://zhxz-xueyoyo.oss-cn-beijing.aliyuncs.com/Image/1677833835777.png","alt":""}}),_c('span',{staticClass:"dataScreen_top_left_span"},[_vm._v(_vm._s(_vm.bclassInfo.schoolName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }